<div class="legal-page">
  <header class="legal-header">
    <a routerLink="/landing" class="legal-header__brand">
      <div class="legal-header__logo"><mat-icon>point_of_sale</mat-icon></div>
      <span>Nova Point</span>
    </a>
    <a routerLink="/landing" class="legal-header__back">
      <mat-icon>arrow_back</mat-icon>
      Back to home
    </a>
  </header>

  <main class="legal-content">
    <h1>Delete Your Account &amp; Data</h1>
    <p class="legal-content__updated">You don't need to be logged in to make this request.</p>

    <section class="info-card">
      <h2>What happens when you submit</h2>
      <ul>
        <li>We review your request and delete the account tied to the email you provide, along with its associated data.</li>
        <li>If you are a shop owner, deleting your account removes your entire shop, including its products, orders, customers, and payment history. This cannot be undone.</li>
        <li>Some records may be retained where we are legally required to keep them (for example, financial or tax records).</li>
        <li>Requests are reviewed manually, so deletion is not instant.</li>
      </ul>
    </section>

    @if (submitted) {
      <div class="success-box">
        <mat-icon>check_circle</mat-icon>
        <div>
          <strong>Request received.</strong>
          <p>We'll review it and process the deletion of the account associated with that email address.</p>
        </div>
      </div>
    } @else {
      <form [formGroup]="form" (ngSubmit)="submit()" class="deletion-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Account email address</mat-label>
          <input matInput formControlName="email" type="email" autocomplete="email" placeholder="you@example.com" />
          <mat-icon matPrefix>email</mat-icon>
          <mat-error *ngIf="form.get('email')?.hasError('required')">Email is required</mat-error>
          <mat-error *ngIf="form.get('email')?.hasError('email')">Enter a valid email</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Reason (optional)</mat-label>
          <textarea matInput formControlName="reason" rows="3" maxlength="1000"></textarea>
        </mat-form-field>

        <p class="form-error" *ngIf="errorMessage">{{ errorMessage }}</p>

        <button mat-raised-button type="submit" class="submit-button" [disabled]="form.invalid || loading">
          @if (loading) {
            <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
          } @else {
            Request account deletion
          }
        </button>
      </form>
    }
  </main>
</div>
